import React from "react";

const serviceTabApi = [
    {
        key:1,
        label: "Solutions",
        children: <div dangerouslySetInnerHTML={{ __html: ` <h2 class="tab-main-heading">What is Fee Delegation?</h2>
        <p class="tabs-para">In the world of crypto and web3 the user who sends a transaction pays a fee.</p>
        <p class="tabs-para">Fee delegation is a feature that allows someone else to pay for it.</p>
        <p class="tabs-para">Removing the need to pay for a fee reduces the interaction of a user to creating a transaction and signing it.</p>
        
        <h3 class="tab-sub-heading">Why is it important?</h3>
        <p class="tabs-para">It stops users from instantly using an application.</p>
        <p class="tabs-para">Users that need to pay for transactions are required to obtain a token from somewhere. Regular users do not know where to go and researching a place to buy and accessing a (de)centralized exchange is too much to ask for a user that wants to use your application.</p>
        <h3 class="tab-sub-heading">What does it allow?</h3>
        <p class="tabs-para">Users can open an application and interact with it instantly. An Application can submit transactions in the background and can no longer be be distinguished from regular (web2) alternatives.</p>
        <p class="tabs-para"> Fee delegation solves the biggest hurdle of user on-boarding to blockchain-applications without invalkeyating the web3-principles.</p>
        
        <div class="btn-group delegation-btn">
          <a href="/" class="primary-btn">Integrate VIP=191</a>
          <a href="/" class="secoundry-btn">Check out our Database<span><img src="../images/btn-arrow-black.svg" alt=""/></span></a>
        </div>` }} />
    },
    { 
        key:2,
        label: "Wallet",
        children:  <div dangerouslySetInnerHTML={{ __html: ` <h2 class="tab-main-heading">What is Fee Wallet?</h2>
        <p class="tabs-para">In the world of crypto and web3 the user who sends a transaction pays a fee.</p>
        <p class="tabs-para">Fee delegation is a feature that allows someone else to pay for it.</p>
        <p class="tabs-para">Removing the need to pay for a fee reduces the interaction of a user to creating a transaction and signing it.</p>
        
        <h3 class="tab-sub-heading">Why is it important?</h3>
        <p class="tabs-para">It stops users from instantly using an application.</p>
        <p class="tabs-para">Users that need to pay for transactions are required to obtain a token from somewhere. Regular users do not know where to go and researching a place to buy and accessing a (de)centralized exchange is too much to ask for a user that wants to use your application.</p>
        <h3 class="tab-sub-heading">What does it allow?</h3>
        <p class="tabs-para">Users can open an application and interact with it instantly. An Application can submit transactions in the background and can no longer be be distinguished from regular (web2) alternatives.</p>
        <p class="tabs-para"> Fee delegation solves the biggest hurdle of user on-boarding to blockchain-applications without invalkeyating the web3-principles.</p>
        
        <div class="btn-group delegation-btn">
          <a href="/" class="primary-btn">Integrate VIP=191</a>
          <a href="/" class="secoundry-btn">Check out our Database<span><img src="../images/btn-arrow-black.svg" alt=""/></span></a>
        </div>` }} />
    },
    { 
        key:3,
        label: "Free Delagation",
        children: <div dangerouslySetInnerHTML={{ __html: ` <h2 class="tab-main-heading">What is Free Delagation?</h2>
        <p class="tabs-para">In the world of crypto and web3 the user who sends a transaction pays a fee.</p>
        <p class="tabs-para">Fee delegation is a feature that allows someone else to pay for it.</p>
        <p class="tabs-para">Removing the need to pay for a fee reduces the interaction of a user to creating a transaction and signing it.</p>
        
        <h3 class="tab-sub-heading">Why is it important?</h3>
        <p class="tabs-para">It stops users from instantly using an application.</p>
        <p class="tabs-para">Users that need to pay for transactions are required to obtain a token from somewhere. Regular users do not know where to go and researching a place to buy and accessing a (de)centralized exchange is too much to ask for a user that wants to use your application.</p>
        <h3 class="tab-sub-heading">What does it allow?</h3>
        <p class="tabs-para">Users can open an application and interact with it instantly. An Application can submit transactions in the background and can no longer be be distinguished from regular (web2) alternatives.</p>
        <p class="tabs-para"> Fee delegation solves the biggest hurdle of user on-boarding to blockchain-applications without invalkeyating the web3-principles.</p>
        
        <div class="btn-group delegation-btn">
          <a href="/" class="primary-btn">Integrate VIP=191</a>
          <a href="/" class="secoundry-btn">Check out our Database<span><img src="../images/btn-arrow-black.svg" alt=""/></span></a>
        </div>` }} />
    },
    {
        key:4,
        label: "Api Overview",
        children:<div dangerouslySetInnerHTML={{ __html: ` <h2 class="tab-main-heading">What is Api Overview?</h2>
        <p class="tabs-para">In the world of crypto and web3 the user who sends a transaction pays a fee.</p>
        <p class="tabs-para">Fee delegation is a feature that allows someone else to pay for it.</p>
        <p class="tabs-para">Removing the need to pay for a fee reduces the interaction of a user to creating a transaction and signing it.</p>
        
        <h3 class="tab-sub-heading">Why is it important?</h3>
        <p class="tabs-para">It stops users from instantly using an application.</p>
        <p class="tabs-para">Users that need to pay for transactions are required to obtain a token from somewhere. Regular users do not know where to go and researching a place to buy and accessing a (de)centralized exchange is too much to ask for a user that wants to use your application.</p>
        <h3 class="tab-sub-heading">What does it allow?</h3>
        <p class="tabs-para">Users can open an application and interact with it instantly. An Application can submit transactions in the background and can no longer be be distinguished from regular (web2) alternatives.</p>
        <p class="tabs-para"> Fee delegation solves the biggest hurdle of user on-boarding to blockchain-applications without invalkeyating the web3-principles.</p>
        
        <div class="btn-group delegation-btn">
          <a href="/" class="primary-btn">Integrate VIP=191</a>
          <a href="/" class="secoundry-btn">Check out our Database<span><img src="../images/btn-arrow-black.svg" alt=""/></span></a>
        </div>` }} />
    },
    {
        key:5,
        label: "Privacy Statments",
        children:<div dangerouslySetInnerHTML={{ __html: ` <h2 class="tab-main-heading">What is Privacy Statments?</h2>
        <p class="tabs-para">In the world of crypto and web3 the user who sends a transaction pays a fee.</p>
        <p class="tabs-para">Fee delegation is a feature that allows someone else to pay for it.</p>
        <p class="tabs-para">Removing the need to pay for a fee reduces the interaction of a user to creating a transaction and signing it.</p>
        
        <h3 class="tab-sub-heading">Why is it important?</h3>
        <p class="tabs-para">It stops users from instantly using an application.</p>
        <p class="tabs-para">Users that need to pay for transactions are required to obtain a token from somewhere. Regular users do not know where to go and researching a place to buy and accessing a (de)centralized exchange is too much to ask for a user that wants to use your application.</p>
        <h3 class="tab-sub-heading">What does it allow?</h3>
        <p class="tabs-para">Users can open an application and interact with it instantly. An Application can submit transactions in the background and can no longer be be distinguished from regular (web2) alternatives.</p>
        <p class="tabs-para"> Fee delegation solves the biggest hurdle of user on-boarding to blockchain-applications without invalkeyating the web3-principles.</p>
        
        <div class="btn-group delegation-btn">
          <a href="/" class="primary-btn">Integrate VIP=191</a>
          <a href="/" class="secoundry-btn">Check out our Database<span><img src="../images/btn-arrow-black.svg" alt=""/></span></a>
        </div>` }} /> 
    },
]

const ApisTab =[
  {
    key:1,
    label: "One Api",
    children:<div dangerouslySetInnerHTML={{ __html: ` <div class="antd-row">
    <div class="left_api">
      <div class="api-img-box">
        <img src="../../images/blockchain-api-img.png" class="img-fluid" alt=""/>
      </div>
    </div>
    <div class="right_api pl-125">
      <div class="">
        <h2 class="sub-heading light-black mb-77">
          Blockchain APIs for <span>Legacy</span> Applications
        </h2>
        <p class="tabs-para mb-77">
          RESTful API to read and write data on the blockchain without touching web3 wallets and libraries. Use legacy applications that support HTTP Post or configured established web services like IFTTT.
        </p>
        <div class="btn-group">
          <a href="/" class="primary-btn  ">Copy Code</a>
          <a href="/" class="secoundry-btn">Read more<span><img src="../../images/btn-arrow-black.svg" alt=""/></span></a>
        </div>
      </div>
    </div>
 </div>` }} /> 
},
{
  key:2,
  label: "How to Start",
  children:<div dangerouslySetInnerHTML={{ __html: ` <div class="antd-row">
  <div class="left_api">
    <div class="api-img-box">
      <img src="../../images/blockchain-api-img.png" class="img-flukey" alt=""/>
    </div>
  </div>
  <div class="right_api pl-125">
    <div class="">
      <h2 class="sub-heading light-black mb-77">
      How to Start <span> APIs </span> Applications
      </h2>
      <p class="tabs-para mb-77">
        RESTful API to read and write data on the blockchain without touching web3 wallets and libraries. Use legacy applications that support HTTP Post or configured established web services like IFTTT.
      </p>
      <div class="btn-group">
        <a href="/" class="primary-btn  ">Copy Code</a>
        <a href="/" class="secoundry-btn">Read more<span><img src="../../images/btn-arrow-black.svg" alt=""/></span></a>
      </div>
    </div>
  </div>
</div>` }} /> 
},
{
  key:3,
  label: "Deploy custom functions",
  children:<div dangerouslySetInnerHTML={{ __html: ` <div class="antd-row">
  <div class="left_api">
    <div class="api-img-box">
      <img src="../../images/blockchain-api-img.png" class="img-flukey" alt=""/>
    </div>
  </div>
  <div class="right_api pl-125">
    <div class="">
      <h2 class="sub-heading light-black mb-77">
      Deploy custom <span>functions </span> Applications
      </h2>
      <p class="tabs-para mb-77">
        RESTful API to read and write data on the blockchain without touching web3 wallets and libraries. Use legacy applications that support HTTP Post or configured established web services like IFTTT.
      </p>
      <div class="btn-group">
        <a href="/" class="primary-btn  ">Copy Code</a>
        <a href="/" class="secoundry-btn">Read more<span><img src="../../images/btn-arrow-black.svg" alt=""/></span></a>
      </div>
    </div>
  </div>
</div>` }} /> 
}
]

const performanceApi = [
  {
    key:1,
    label: "Historical Performance",
    children:<div dangerouslySetInnerHTML={{ __html: ` <div class="antd-row">
      <div class="performance_left">
        <h2 class="sub-heading ">
          Historical <span>Performance</span>
        </h2>
        <p class="tabs-para">
          See in one place how much VTHO you consumed and what it cost. A daily average gives you a guestimate of your costs and allows you to calculate future costs similar to hosting costs.
        </p>
        <ul class="tab-over-inner mb-77">
            <li class="list">
                Whitelist multiple Origins to pay for transaction from specific wallets or internal implementaion (Node-Services, Development-enviroment, its.)
            </li>
            <li class="list">
                Whitelist multlple to pay for all interactions with a contract or wallet 
            </li>
            <li class="list">
                Congigure contract for extended logic to support complex logics (only NFT-Token-Holders, Users with Roles, etc)
            </li>
          </ul>
        <div class="btn-group">
          <a href="/" class="primary-btn">Find out costs</a>
          <a href="/" class="secoundry-btn">Read more<span><img src="../../images/btn-arrow-black.svg" alt=""/></span></a>
        </div>
      </div>
    <div class="performance_right">
      <div class="performance_right_inner">
          <div class="performance-detail">
            <ul class="mb-77">
              <li>
                <h6 class="">Daily Average</h6>
                <div class="performance-inner">
                  <h4>114 VTHO</h4>
                  <p>$0.47</p>
                </div>
              </li>
              <li>
                <h6 class="">Daily Tranactions</h6>
                <div class="performance-inner">
                  <h4>23 Tx</h4>
                  <p>by 4 Origins</p>
                </div>
              </li>
              <li>
                <h6 class="">Errors</h6>
                <div class="performance-inner">
                  <h4>0</h4>
                  <p></p>
                </div>
              </li>
            </ul>
            <div class="performance-right-img">
                <img src="../../images/History-graph.png" class="img-fluid" alt=""/>
            </div>
          </div>
      </div>
    </div>` }} /> 
  },
  {
    key:2,
    label: "Transaction-Details",
    children:<div dangerouslySetInnerHTML={{ __html: ` <div class="antd-row">
      <div class="performance_left">
        <h2 class="sub-heading ">
        Transaction <span>Details</span>
        </h2>
        <p class="tabs-para">
          See in one place how much VTHO you consumed and what it cost. A daily average gives you a guestimate of your costs and allows you to calculate future costs similar to hosting costs.
        </p>
        <ul class="tab-over-inner mb-77">
            <li class="list">
                Whitelist multiple Origins to pay for transaction from specific wallets or internal implementaion (Node-Services, Development-enviroment, its.)
            </li>
            <li class="list">
                Whitelist multlple to pay for all interactions with a contract or wallet 
            </li>
            <li class="list">
                Congigure contract for extended logic to support complex logics (only NFT-Token-Holders, Users with Roles, etc)
            </li>
          </ul>
        <div class="btn-group">
          <a href="/" class="primary-btn">Find out costs</a>
          <a href="/" class="secoundry-btn">Read more<span><img src="../../images/btn-arrow-black.svg" alt=""/></span></a>
        </div>
      </div>
    <div class="performance_right">
      <div class="performance_right_inner">
          <div class="performance-detail">
            <ul class="mb-77">
              <li>
                <h6 class="">Daily Average</h6>
                <div class="performance-inner">
                  <h4>114 VTHO</h4>
                  <p>$0.47</p>
                </div>
              </li>
              <li>
                <h6 class="">Daily Tranactions</h6>
                <div class="performance-inner">
                  <h4>23 Tx</h4>
                  <p>by 4 Origins</p>
                </div>
              </li>
              <li>
                <h6 class="">Errors</h6>
                <div class="performance-inner">
                  <h4>0</h4>
                  <p></p>
                </div>
              </li>
            </ul>
            <div class="performance-right-img">
                <img src="../../images/History-graph.png" class="img-flukey" alt=""/>
            </div>
          </div>
      </div>
    </div>` }} /> 
  },
  {
    key:3,
    label: "Automation with Schedulers",
    children:<div dangerouslySetInnerHTML={{ __html: ` <div class="antd-row">
      <div class="performance_left">
        <h2 class="sub-heading ">
        Automation with  <span>Schedulers</span>
        </h2>
        <p class="tabs-para">
          See in one place how much VTHO you consumed and what it cost. A daily average gives you a guestimate of your costs and allows you to calculate future costs similar to hosting costs.
        </p>
        <ul class="tab-over-inner mb-77">
            <li class="list">
                Whitelist multiple Origins to pay for transaction from specific wallets or internal implementaion (Node-Services, Development-enviroment, its.)
            </li>
            <li class="list">
                Whitelist multlple to pay for all interactions with a contract or wallet 
            </li>
            <li class="list">
                Congigure contract for extended logic to support complex logics (only NFT-Token-Holders, Users with Roles, etc)
            </li>
          </ul>
        <div class="btn-group">
          <a href="/" class="primary-btn">Find out costs</a>
          <a href="/" class="secoundry-btn">Read more<span><img src="../../images/btn-arrow-black.svg" alt=""/></span></a>
        </div>
      </div>
    <div class="performance_right">
      <div class="performance_right_inner">
          <div class="performance-detail">
            <ul class="mb-77">
              <li>
                <h6 class="">Daily Average</h6>
                <div class="performance-inner">
                  <h4>114 VTHO</h4>
                  <p>$0.47</p>
                </div>
              </li>
              <li>
                <h6 class="">Daily Tranactions</h6>
                <div class="performance-inner">
                  <h4>23 Tx</h4>
                  <p>by 4 Origins</p>
                </div>
              </li>
              <li>
                <h6 class="">Errors</h6>
                <div class="performance-inner">
                  <h4>0</h4>
                  <p></p>
                </div>
              </li>
            </ul>
            <div class="performance-right-img">
                <img src="../../images/History-graph.png" class="img-flukey" alt=""/>
            </div>
          </div>
      </div>
    </div>` }} /> 
  },
  
]

export default serviceTabApi;
 export  {ApisTab,performanceApi};
